import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';
declare var $;
@Component({
  selector: 'app-instance-select-multi',
  templateUrl: './instance-select-multi.component.html',
  styleUrls: ['./instance-select-multi.component.css']
})
export class InstanceSelectMultiComponent implements OnInit {
  // 接收父组件的数据：初始化选中的实体
  @Input() initSelectInstances:any;
  // 新增或删除关联实体后向父组件发射数据
  @Output('voted') selectInstanceChange = new EventEmitter<any>();   
  // 概念模型树，默认不可选中的父级概念结点
  readonlySelfIds = [];
  // 概念模型树数据
  ontologyTreeDatas = [];
  // 当前选中的概念id
  conceptId:string = '';
  // 搜索关键字
  keyword:string = '';
  // 查询出实体列表
  instanceList:any = [];
  // 选中的实体数据
  selectedInstances:any = [];
  constructor(
    private instanceModuleService: InstanceModuleService,
    private jwt: SwJwtService,
    private kmsService: KmsService,
    private box: SwMassageBoxService
  ) { }

  ngOnInit() {
    this.getOnlogyTreePageList();
  }

  ngOnChanges(){
    this.selectedInstances = JSON.parse(JSON.stringify(this.initSelectInstances));
  }

  // 请求概念数据模型方法
  getOnlogyTreePageList() {
    this.kmsService.getConceptTreeData({}).subscribe(
        data => {
            if (data.code == 200) {
              if (!data.data) {
                  this.ontologyTreeDatas = [];
              }
              this.ontologyTreeDatas = data.data;
              this.readonlySelfIds = ['0'];
              // 获取不可选择的概念树节点
              this.ontologyTreeDatas.forEach(item => {
                if(this.ontologyTreeDatas.filter(item1 => item1.pid == item.id).length > 0){
                    this.readonlySelfIds.push(item.id);
                }
              });

              // 获取第一个叶子节点，作为默认显示的概念
              // 先找到概念树下面展示的第一个节点
              let firstNode = this.ontologyTreeDatas.filter(item => item.pid == 'root')[0];
              // 先判断该节点是否为叶子节点，是，设置选中；否，找到该节点下的第一个叶子节点并设置选中
              if(this.readonlySelfIds.filter(el => el == firstNode.id).length == 0){
                this.conceptId = firstNode.id;
              }else{
                let firstLeafNode = this.getFirstLeafNode(firstNode.id);
                this.conceptId = firstLeafNode.id;
              }
            }
        }
    );
  }

  // 查找某个节点下的第一个叶子节点
  getFirstLeafNode(parentId){
    let childs = this.ontologyTreeDatas.filter(item => item.pid == parentId);
    let index = -1;
    for(let i=0;i<childs.length;i++){
        if(this.readonlySelfIds.filter(el => el == childs[i].id).length == 0){
            index = i;
            break;
        }
    }
    if(index >= 0){
        return childs[index] 
    }else{
        return this.getFirstLeafNode(childs[0].id)
    }
  }

  // 列表点击事件,选择实体
  handleSelectClick(data) {
    this.keyword = '';
    if (this.selectedInstances.length > 0) {
        let items = this.selectedInstances.filter(item => item.instanceName == data.instanceName);
        if (items.length <= 0) {
          this.selectedInstances.push({
            instanceName: data.instanceName,
            instanceId: data.instanceId
          });
          // 选中项发生改变时向父组件发射数据
          this.selectInstanceChange.emit(this.selectedInstances);
        }
    } else {
      this.selectedInstances.push({
        instanceName: data.instanceName,
        instanceId: data.instanceId
      });
      // 选中项发生改变时向父组件发射数据
      this.selectInstanceChange.emit(this.selectedInstances);
    }
    this.instanceList = [];
  }

  // 相关人物搜索实体信息
  handleSearchChange(event) {
    this.getInstanceList(event);
  }

  // 相关人物，请求实体列表数据
  getInstanceList(name) {
    let Params = {
        current: 1,
        size: 30,
        instanceName: $.trim(name),
        conceptId: this.conceptId
    };
    this.kmsService.getInstanceQueryList(Params).subscribe(
        result => {
            if (result.code == 200) {
                this.instanceList = result.data.records;
            } else {
                this.box.waring(result.msg);
            }
        }
    );
  }

  // 相关人物输入框获取焦点时
  handelFocus() {
      this.getInstanceList(this.keyword);
  }

  // 相关人物输入框失去焦点时
  handelBlur() {
    setTimeout(() => {
        this.instanceList = [];
    }, 200);
  }

  // 相关人物添加实体信息
  handleAddClick() {
    if(!this.conceptId){
      this.box.waring('请选择所属概念！');
      return;
    }
    if($.trim(this.keyword)) {
      const userRole = this.jwt.getToken('userRole');
      let conceptData = this.ontologyTreeDatas.filter(item => item.id == this.conceptId)[0];
      this.kmsService.getInstanceMaxSerialNumber().subscribe(
        result => {
            if (result.code == '200') {
              const serialNumber = result.data;
              let params = {
                currentUserRole: userRole == '知识编辑' ? 1 : 2,
                serialNumber: serialNumber,
                instanceId: this.instanceModuleService.uuid2(),
                instanceName: $.trim(this.keyword),
                conceptCode: conceptData.code,
                conceptId: conceptData.id,
                conceptName: conceptData.name,
                mapping: conceptData.mapping,
                attributes: [],
                tags:[],
                geoSaveList:[],
                approvalStatus: 0
              }
              this.kmsService.saveInstanceUpdate(params).subscribe(
                res => {
                  if(res.code == '200'){
                    this.handleSelectClick(res.data);
                    // 增量更新索引
                    this.updateIndex(res.data.instanceId);
                  }else{
                    this.box.danger(res.msg);
                  }
                }
              )
            }
        }
      );
    }
  }

  // 增量更新索引
  updateIndex(instanceId){
    this.kmsService.updateIndexByInstanceId(instanceId).subscribe(
        data => {
            if(data.code != '200'){
              console.log('索引更新失败!');
            }
        }
    )
  }

  // 相关人物删除实体信息
  handelDelClick(index) {
    this.selectedInstances.splice(index, 1);
    // 选中项发生改变时向父组件发射数据
    this.selectInstanceChange.emit(this.selectedInstances);
  }
}
